import { useState, useEffect } from 'react';

/**
 * Custom hook to track whether a given CSS media query matches the current viewport.
 * @param query - A CSS media query string (e.g., '(min-width: 768px)').
 * @returns `true` if the media query matches, `false` otherwise.
 */
export const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const updateMatch = () => setMatches(mediaQuery.matches);

    updateMatch();
    mediaQuery.addEventListener('change', updateMatch);

    return () => mediaQuery.removeEventListener('change', updateMatch);
  }, [query]);

  return matches;
};
